module.exports = __webpack_public_path__ + "img/file-earmark-arrow-down.474f30bd.svg";